module.exports = __webpack_public_path__ + "img/octoprint_logo.png";